module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "comments"
  }, [_vm._c('div', {
    staticClass: "row xs-mb-30"
  }, [_vm._c('div', {
    staticClass: "col-xs-6"
  }, [_vm._c('h3', {
    staticClass: "pull-left xs-m-0"
  }, [_vm._v("Comments "), (_vm.comments.length > 0) ? _vm._c('span', {
    staticStyle: {
      "font-size": "70%"
    }
  }, [_vm._v("(" + _vm._s(_vm.filteredComments.length) + ")")]) : _vm._e()])]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-6"
  }, [(!_vm.currentUser.loggedIn) ? _vm._c('router-link', {
    staticClass: "btn btn-default pull-right",
    attrs: {
      "to": {
        name: 'login',
        query: {
          redirect: '/blog-article/' + _vm.articleId
        }
      }
    }
  }, [_vm._c('i', {
    staticClass: "fas fa-sign-in-alt"
  }), _vm._v("   Login to comment")]) : _vm._e()], 1)]), _vm._v(" "), _vm._c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.currentUser.loggedIn) ? _vm._c('div', {
    staticClass: "write"
  }, [_vm._c('div', {
    staticClass: "input"
  }, [_vm._m(0), _vm._v(" "), _vm._c('Editable', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.commentText),
      expression: "commentText"
    }],
    attrs: {
      "placeholder": "Write a public comment..."
    },
    domProps: {
      "value": (_vm.commentText)
    },
    on: {
      "input": function($event) {
        _vm.commentText = $event
      }
    }
  })], 1), _vm._v(" "), _vm._c('div', {
    staticClass: "buttons text-right"
  }, [(!_vm.status) ? _vm._c('button', {
    staticClass: "btn btn-primary xs-ml-20",
    attrs: {
      "disabled": !_vm.commentText
    },
    on: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_vm._c('i', {
    staticClass: "far fa-comment"
  }), _vm._v("   Submit")]) : _vm._c('button', {
    staticClass: "btn btn-default xs-ml-20",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Submitting...")])])]) : _vm._e(), _vm._v(" "), (_vm.filteredComments.length > 0) ? _vm._c('div', _vm._l((_vm.filteredComments), function(comment) {
    return _vm._c('BlogComment', {
      attrs: {
        "show-delete": _vm.showDelete,
        "comment": comment,
        "blogArticleId": _vm.articleId
      }
    })
  })) : _vm._c('div', {
    staticClass: "xs-pt-30"
  }, [_vm._v("\n    There are no comments for this article.\n  ")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "avatar"
  }, [_vm._c('img', {
    attrs: {
      "src": "/static/img/avatar.png",
      "alt": "Avatar"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-801e1e50!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/blog/BlogCommentsList.vue
// module id = 691
// module chunks = 1